import { animated } from "@react-spring/web";
import PropTypes from "prop-types";
import "./DisplayQuestion.scss";
import enStrings from "../../services/strings.en.json";
import { Question } from "../../models/question.js";

/**
 * @component
 * @param {Object} args
 * @param {Question} args.question
 * @param {"left" | "right"} args.orientation
 * @param {{ opacity: import("@react-spring/web").SpringValue<number> }} args.springs
 * @param {React.StyleHTMLAttributes<HTMLHeadingElement> | undefined} args.style
 * @param {string} args.text
 * @param {React.MutableRefObject<HTMLDivElement | null>} args.containerRef
 */
function DisplayQuestion({
  question,
  orientation,
  springs,
  style,
  text,
  containerRef,
}) {
  let containerHeight = window.innerHeight;
  if (containerRef.current) {
    const { height } = containerRef.current.getBoundingClientRect();
    containerHeight = height;
  }
  const computedStyles = {
    fontSize: `${containerHeight * 0.0741}px`,
    lineHeight: `${containerHeight * 0.0796}px`,
  };
  return (
    <animated.h1
      className={`dataviz__prompt${
        orientation ? ` dataviz__prompt--${orientation} ` : ""
      }`}
      style={{
        ...style,
        ...springs,
        ...computedStyles,
        color: question.getTopic(enStrings).color.text,
      }}
    >
      {text}
    </animated.h1>
  );
}

DisplayQuestion.propTypes = {
  orientation: PropTypes.oneOf(["left", "right"]),
  question: PropTypes.instanceOf(Question).isRequired,
  text: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  springs: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object.isRequired,
  containerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
};

DisplayQuestion.defaultProps = {
  orientation: "left",
};
export default DisplayQuestion;
